import { useEffect, useRef } from "react";
import { useState } from "react";

import Label from "../../components/forms/ui/label/Label";
import FormCreator from "../../components/forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import { CreateEventGalleryForm } from "./data/CreateEventGalleryForm.Data";
import { useLazyGetAllDropDownForEventManagementQuery } from "../../app/services/EventManagement/EventManagementApi";
import { setAllDropDownFieldsBatch } from "../../utils/FormFields/FieldsSetting/SetFieldSetting";
import SwalAlert from "../../services/swalService/SwalService";
import {
  useAddEventGalleryDetailsMutation,
  useLazyGetEventGalleryDetailByIdQuery,
} from "../../app/services/EventGallery/EventGalleryApi";
import { useNavigate } from "react-router-dom";
import DataLoader from "../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import { getAuditContext } from "../../lib/authenticationLibrary";

const ManageEventGalleryForm = () => {
  const manageEventGalleryRef = useRef();
  const [form, setForm] = useState(CreateEventGalleryForm);
  const { success, error } = SwalAlert();
  const audit = getAuditContext();
  const navigate = useNavigate();

  const [
    geEventListDropDown,
    {
      isLoading: viewEventListDropDownIsLoading,
      data: viewEventListDropDownData,
      isSuccess: viewEvenetListDropDownIsSuccess,
    },
  ] = useLazyGetAllDropDownForEventManagementQuery();
  const [
    addEventGalleryDetails,
    {
      isSuccess: isSuccessEventGallery,
      isFetching: isFetchingEventGallery,
      data: addEventGalleryResponse,
    },
  ] = useAddEventGalleryDetailsMutation();

  const viewListDropDowns = [
    { dropdownName: "Gallery Event Type", fieldId: "eventType" },
    { dropdownName: "Gallery Event Topic Drp", fieldId: "eventTopic" },
  ];

  useEffect(() => {
    if (
      !isFetchingEventGallery &&
      isSuccessEventGallery &&
      addEventGalleryResponse
    ) {
      if (addEventGalleryResponse.hasError === false) {
        success("Add Event Gallery Successfully");
        handleBack();
      } else {
        error(addEventGalleryResponse.errorMessage);
      }
    }
  }, [isFetchingEventGallery, isSuccessEventGallery, addEventGalleryResponse]);

  // Effect for set dropdown
  useEffect(() => {
    if (
      !viewEventListDropDownIsLoading &&
      viewEvenetListDropDownIsSuccess &&
      viewEventListDropDownData
    ) {
      // Updates dropdown fields in the form based on the fetched data
      setAllDropDownFieldsBatch(
        CreateEventGalleryForm,
        viewListDropDowns,
        viewEventListDropDownData
      );
    }
  }, [
    viewEventListDropDownIsLoading,
    viewEvenetListDropDownIsSuccess,
    viewEventListDropDownData,
  ]);

  useEffect(() => {
    geEventListDropDown();
  }, []);

  const handleSave = () => {
    const formData = manageEventGalleryRef.current.getFormData();
    if (!formData) {
      return error("Please fill all mandatory fields.", "");
    }

    const request = {
      EventName: formData?.eventName || null,
      EventDate: formData?.eventDate || null,
      EventTypeId: formData?.eventType?.value || null,
      // EventTopicId: formData?.eventTopic?.value || null,
      EventTopicId:
        formData?.eventTopic?.value ||
        formData?.eventTopic?.value ||
        formData?.eventTopic.join(", "),
      IsPublish: formData?.isPublished,
      IsPrivate: formData?.isPrivate,
      CreatedBy: audit.adminUserId,
      CreatedAppId: audit.appId,
    };
    addEventGalleryDetails(request);
  };

  // On handle back click method
  const handleBack = () => {
    navigate("/EventsGalleryList");
  };

  return (
    <div className="form-card">
      <div className="row">
        {viewEventListDropDownData ? (
          <FormCreator ref={manageEventGalleryRef} config={form}></FormCreator>
        ) : (
          <DataLoader />
        )}
        <div className="">
          <Buttons
            onClick={() => handleSave()}
            buttonText={"Save"}
            buttonTypeClassName="theme-btn btn mt-auto"
            isLoading={false}
          />
        </div>
      </div>
    </div>
  );
};
export default ManageEventGalleryForm;
